import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KCompanyItemCardComponent } from './k-company-item-card.component';
import { KCardsModule } from '../k-cards.module';
import { InfoIconModule } from '../../info-icon/info-icon.module';
import { DirectivesModule } from 'app/common/directives/directives.module';
import { BadgeModule } from 'primeng/badge';



@NgModule({
  declarations: [
    KCompanyItemCardComponent
  ],
  imports: [
    CommonModule,
    KCardsModule,
    InfoIconModule,
    DirectivesModule,
    BadgeModule
  ],
  exports: [
    KCompanyItemCardComponent
  ]
})
export class KCompanyItemCardModule { }
